import React from 'react'
import PropTypes from 'prop-types'
import { convertToRaw } from 'draft-js'
import { stateToHTML } from 'draft-js-export-html'
import { getDefaultRichStyleConfig } from '../../../../services/draft-state/utils'

const styles = {
  fixedWidth: {
    fontFamily: 'monospace',
    margin: '0 10px',
    width: '40%',
    height: '500px',
    fontSize: 'smaller',
    float: 'left',
  },
}

const StateView = ({ editorState }) => {
  const rawState = convertToRaw(editorState.getCurrentContent())
  const json = JSON.stringify(rawState, null, 4)

  return (
    <textarea
      readOnly
      style={styles.fixedWidth}
      value={json}
    />
  )
}

StateView.propTypes = {
  editorState: PropTypes.object.isRequired,
}

const HtmlView = ({ editorState }) => {
  const contentState = editorState.getCurrentContent()
  const html = stateToHTML(contentState, getDefaultRichStyleConfig())

  return (
    <textarea
      readOnly
      style={styles.fixedWidth}
      value={html}
    />
  )
}

HtmlView.propTypes = {
  editorState: PropTypes.object.isRequired,
}

const LogEditorState = ({ state, buttonText }) => (
  <input
    type="button"
    onClick={() => console.log(state.toJS())}
    value={buttonText}
  />
)

LogEditorState.propTypes = {
  state: PropTypes.object.isRequired,
  buttonText: PropTypes.string.isRequired,
}

const LogContentState = ({ state, buttonText }) => (
  <input
    type="button"
    onClick={() => console.log(convertToRaw(state.getCurrentContent()))}
    value={buttonText}
  />
)

LogContentState.propTypes = {
  state: PropTypes.object.isRequired,
  buttonText: PropTypes.string.isRequired,
}

export { StateView, HtmlView, LogEditorState, LogContentState }



// WEBPACK FOOTER //
// ./src/components/sitewide/RichTextEditor/Auditor/DebugViews.js